module.exports = __webpack_public_path__ + "img/Ic_pinterest.1bfea9cd.svg";